import { Component, Input } from '@angular/core';
import { DataTableColumnBadge } from './data-table-column-badge.config';

@Component({
  selector: 'data-table-column-badge',
  imports: [],
  templateUrl: './data-table-column-badge.component.html',
  styleUrl: './data-table-column-badge.component.scss'
})
export class DataTableColumnBadgeComponent {
  @Input() column!: DataTableColumnBadge;
  @Input() item!: any;

  get label(): string {
    const value = this.column?.value?.(this.item);
    return value === null || value === undefined || value === '' ? '' : String(value);
  }
}
